export default "__VITE_ASSET__CEY0yW$A__"